import baseline, { appTextStyle } from '../../app-ui/baseline';
import React from 'react';
import RecoverableImage from '../images/RecoverableImage';
import SponsoredExposure from '../ads/SponsoredExposure';
import { CampaignLink, SponsoredLabel } from '../ads/SponsoredContent';
import { campaignDestination } from '../ads/placement';
import AlbumContentTitle from '../../components/content/AlbumContentTitle';
import { isNewRelease } from './contracts';
export function BrowseSponsoredAlbum({ campaign, releases = false }) {
  const album = campaign.albums?.[0];
  if (!album) return null;
  const placementKey = campaign.placements[0].placementKey;
  return (
    <SponsoredExposure
      campaignId={campaign.id}
      placementKey={placementKey}
      className="pp-browse-ad-album"
    >
      <CampaignLink
        campaign={campaign}
        placementKey={placementKey}
        destination={campaignDestination(campaign, album)}
        className="pp-browse-review-album-summary"
      >
        <span className="pp-browse-cover">
          {album.imageUrl && <RecoverableImage src={album.imageUrl} alt="" loading="lazy" />}
        </span>
        <AlbumContentTitle item={album} title={album.title} />
        <span className="pp-browse-artist">{album.artistName || album.artist?.name}</span>
        <span className="pp-browse-date">{(album.genres || []).slice(0, 3).join(', ')}</span>
        <span className="pp-browse-date">
          {album.releaseDate}
          {releases && isNewRelease(album.releaseDate) && <i className="pp-browse-new">NEW</i>}
        </span>
      </CampaignLink>
      <SponsoredLabel campaign={campaign} placementKey={placementKey} reasonChip />
    </SponsoredExposure>
  );
}
export function BrowseInlineAd({ campaign }) {
  const { inlineAd } = baseline.lists;
  const placementKey = campaign.placements[0].placementKey,
    album = campaign.albums?.[0],
    image = campaign.imageUrl || album?.imageUrl;
  return (
    <SponsoredExposure
      campaignId={campaign.id}
      placementKey={placementKey}
      className="pp-browse-inline-ad pp-native-inline-ad"
    >
      <CampaignLink
        campaign={campaign}
        placementKey={placementKey}
        destination={campaignDestination(campaign, album)}
        className="pp-browse-inline-link"
      >
        {image && <img src={image} alt="" loading="lazy" style={inlineAd.inlineImage} />}
        <div
          style={{
            gap: inlineAd.inlineCopy.gap,
            padding: `${inlineAd.inlineCopy.paddingVertical}px ${inlineAd.inlineCopy.paddingRight}px ${inlineAd.inlineCopy.paddingVertical}px ${inlineAd.inlineCopy.paddingHorizontal}px`,
          }}
        >
          <strong style={appTextStyle(inlineAd.inlineTitle)}>{campaign.headline}</strong>
          {campaign.subheadline && (
            <p style={appTextStyle(inlineAd.inlineDescription)}>{campaign.subheadline}</p>
          )}
        </div>
      </CampaignLink>
      <SponsoredLabel campaign={campaign} placementKey={placementKey} plain />
    </SponsoredExposure>
  );
}
